module.exports = __webpack_public_path__ + "img/img_inner_greentartan.fcbdd2de.png";